// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3856":"5ba8ab41b40dcfa1","4545":"8b5c8a1a07f88a06","9424":"abc349c2fe1dbbb8"}[chunkId] + ".js";
};